module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-nele.705ff3d5.jpeg";